( function () {
	'use strict';

	/* eslint max-params:0 */
	function DeleteTemplateCtrl ( $scope, dataservice, logger, apiService, Session, $modal, TOOLTIP_MESSAGES, _ ) {
		var self = this;

		self.loading = false;
		self.tooltip = TOOLTIP_MESSAGES.deleteMsg;

		function deleteTemplate () {
			$scope.templates = _.reject( $scope.templates, { 'id' : $scope.templateModel.id } );
			apiService.deleteTemplate
				.remove( {
					'templateId' : $scope.templateModel.id
				} );
		}

		function deleteTemplateModal () {
			self.modalInstance = $modal.open( {
				'templateUrl'  : '/templates/components/delete-modal/delete-confirmation.html',
				'controller'   : 'DeleteConfirmationController',
				'controllerAs' : 'vm',
				'resolve'      : {
					'type' : function () {
						return 'Template';
					}
				}
			} );

			return self.modalInstance.result.then( function () {
				self.deleteTemplate();
			} );
		}

		function activate () {
			logger.info( 'Activated Delete Template' );
		}

		activate();

		self.deleteTemplateModal = deleteTemplateModal;
		self.deleteTemplate      = deleteTemplate;
	}

	angular
		.module( 'app.templates' )
		.controller( 'DeleteTemplateCtrl', DeleteTemplateCtrl );

	DeleteTemplateCtrl.$inject = [ '$scope', 'coreservice', 'logger', 'apiService', 'Session', '$modal', 'TOOLTIP_MESSAGES', '_' ];
} )( );
